import { render, staticRenderFns } from "./PSpinner.vue?vue&type=template&id=2a639549&scoped=true"
import script from "./PSpinner.vue?vue&type=script&lang=js"
export * from "./PSpinner.vue?vue&type=script&lang=js"
import style0 from "./PSpinner.vue?vue&type=style&index=0&id=2a639549&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a639549",
  null
  
)

export default component.exports